// extracted by mini-css-extract-plugin
export default {"snackbar":"SnackError_snackbar__BK88V","showError":"SnackError_showError__4aPCx"};